import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Status } from "../../../../common/constants";
import { sendInviteEmailUrl } from "../../../../config";
import api from '../../../../api';

interface ISendEmailState {
  status: string;
  msg: string | null;
  error: string | null;
}

const initialState: ISendEmailState = {
  status: Status.IDLE,
  msg: null,
  error: null,
};

export const sendEmail: any = createAsyncThunk("sendEmail", async ({ name, email,isReinvite=true }: { name: string, email: string ,isReinvite:boolean}) => {
    try {
      const sendEmailUrl = sendInviteEmailUrl + `?name=${encodeURIComponent(name)}&email=${encodeURIComponent(email)}&isReinvite=${isReinvite}`;

      const response = await api.put(sendEmailUrl, {});
      return response.data;
    } catch (error) {
      throw error.response.data.message;
    }
  });

const sendEmailSlice = createSlice({
  name: "sendEmail",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(sendEmail.pending, (state) => {
        state.status = Status.PENDING;
        state.msg = null;
      })
      .addCase(sendEmail.fulfilled, (state, action) => {
        state.msg = action.payload.message;
        state.status = Status.SUCCESS;
      })
      .addCase(sendEmail.rejected, (state, action) => {
        state.status = Status.FAILED;
        state.error = action.error.message;
        state.msg = action.error.message || 'Something went wrong!' ;
      });
  },
});

type Selector = {
  sendEmailApi: ReturnType<
    typeof sendEmailSlice.reducer
  >;
};

export const selector = (store: Selector) => store['sendEmailApi'];

export default sendEmailSlice.reducer;